/* eslint-disable react/prop-types */
/* eslint-disable no-useless-return */
/* eslint-disable no-use-before-define */
/* eslint-disable no-lonely-if */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext, useRef } from 'react';
import useCommonStyles from '../../useStyles';
import PageTitle from '../../../../components/PageTitle/PageTitle';
import useForm from '../../../../hooks/useForm';
import { DialogContext } from '../../../../contexts/DialogContext';
import { dialogActions } from '../../../../reducers/dialogReducer';
import {
  measureStyleType,
  positionType,
  sinteringSizePath,
  sinteringSizeType,
  specConfigItemStatus,
} from '../../../../constants/enums';
import { checkSpecConfigDiff } from '../../../../Utils/arrayUtil';
import regex from '../../../../constants/validationRegex';
import TransInfo from './TransInfo';
import Snackbar from '../../../../components/Snackbar/Snackbar';
import QCSinteringElectrical from './QCSinteringElectrical';
import useCancelToken from '../../../../hooks/useCancelToken';
import {
  deleteTransferQcData,
  getSinterBase,
  getSinterCheck,
  sinterCheckSetting,
} from '../../../../services/qc';

const QCSinteringElectricalPage = () => {
  const { dialogDispatch, infoDialogDispatch } = useContext(DialogContext);
  const isMultipleTransId = useRef(false);
  const isMultipleTransQty = useRef(0);
  const [transId, setTransId] = useState('');
  const [transIdErr, setTransIdErr] = useState(false);
  const [transIdErrMsg, setTransIdErrMsg] = useState('請輸入正確的移轉單號');
  const [subTransIds, setSubTransIds] = useState([]);
  const [elecStoveSelection, setElecStoveSelection] = useState([]);
  const [sinterManualResult, setSinterManualResult] = useState(null);
  const [originalSinterManualResult, setOriginalSinterManualResult] = useState(null);
  const initialTransInfo = {
    transId: '',
    sinterCheckId: '',
    customer: '-',
    elName: '-',
    elecStoveNo: '-',
    position: '0',
    layer: '0',
    transQty: '-',
    sampleQty: 20,
    isRStick: 0,
    machineName: '-',
  };
  const {
    formData: transInfo,
    setFormData: setTransInfo,
    formErr: transInfoErr,
    setFormErr: setTransInfoErr,
    resetFormData: resetTransInfo,
    resetFormErr: resetTransInfoErr,
  } = useForm(initialTransInfo);
  const [currentSpec, setCurrentSpec] = useState([]);
  const [lastSubSpec, setLastSubSpec] = useState('');
  const [specConfig, setSpecConfig] = useState([]);
  const [diffNLMeasure, setDiffNLMeasure] = useState([]);
  const [measureStyle, setMeasureStyle] = useState(0); // For measureStyle selection render
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [showPaper, setShowPaper] = useState(false);
  const [renderRow, setRenderRow] = useState([]);
  const [resultNote, setResultNote] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [warningMsg, setWarningMsg] = useState('');
  const [oneColumn, setOneColumn] = useState(false);
  const [showUnfinishAlert, setShowUnfinishAlert] = useState(true);
  const [resetTransInfoField, setResetTransInfoField] = useState(false);
  const [disabledDeleteBtn, setDisabledDeleteBtn] = useState(false);
  const [enableDelete, setEnableDelete] = useState(false);
  const finalTransId = useRef(''); // 負責存取最後一次的 merge 移轉單號
  const currentIsRStick = useRef(0);
  const currentMeasureStyle = useRef(0); // For current measureStyle data store
  const lastMeasureStyle = useRef(0); // To determine if measureStyle has changed
  const transDefectTypes = useRef([]);
  const realTimeTransId = useRef('');
  const lastTransId = useRef('');
  const currentTransId = useRef(null);
  const currentSubTransId = useRef(null);
  const outSpecCount = useRef(0);
  const formResult = useRef(false);
  const sampleQty = useRef(0);
  const tableEl = useRef(null);
  const tableTimer = useRef(null);
  const warningTimer = useRef(null);
  const successTimer = useRef(null);
  const inspectionCheck = useRef(null);
  const inspectionSpecConfig = useRef(null);
  const currentSubSpec = useRef('');
  // 舊的 measureConfig
  const measureConfig = useRef([]);
  // 新的 measureConfig
  const currentMeasureConfig = useRef([]);
  const ampSpec = useRef([]);
  const elecStoveNumber = useRef('0');
  const commonClasses = useCommonStyles().classes;
  const { newCancelToken } = useCancelToken();
  const styleId = useRef(null);
  const sizeType = sinteringSizeType.SIZE;

  const resetAllField = () => {
    setTransId('');
    resetTransInfo();
    setSinterManualResult(null);
    setOriginalSinterManualResult(null);
    resetTransInfoErr();
    setTransIdErr(false);
    setResultNote('');
    setRenderRow([]);
    setShowTable(false);
    setShowPaper(false);
    currentSubSpec.current = '';
    setShowUnfinishAlert(true);
    setDisabledDeleteBtn(false);
    setEnableDelete(false);
    realTimeTransId.current = '';
    lastTransId.current = '';
    currentIsRStick.current = 0;
    currentTransId.current = null;
    currentSubTransId.current = null;
    lastMeasureStyle.current = 0;
    outSpecCount.current = 0;
    sampleQty.current = 0;
    inspectionCheck.current = null;
    inspectionSpecConfig.current = null;
    setResetTransInfoField(true);
    isMultipleTransQty.current = 0;
    finalTransId.current = '';
    isMultipleTransId.current = false;
    elecStoveNumber.current = '0';
  };

  const validationTransInfo = (type) => {
    resetTransInfoErr();
    if (realTimeTransId.current.length === 0) {
      setTransIdErr(true);
      return false;
    }
    if ((transInfo.elecStoveNo === '0' || transInfo.elecStoveNo === '-') && type === 'blur') {
      return false;
    }
    if (transInfo.elecStoveNo === '0' || transInfo.elecStoveNo === '-') {
      setTransInfoErr((prev) => ({
        ...prev,
        elecStoveNo: true,
      }));
      return false;
    }
    return true;
  };

  const handleShowTable = (type) => {
    resetTransInfoErr();
    setShowPaper(true);
    if (!validationTransInfo(type)) return;
    setShowTable(true);
    // setShowTable(false);
    // setIsLoading(true);
    // clearTimeout(tableTimer.current);
    // tableTimer.current = setTimeout(() => {
    //   setIsLoading(false);
    //   setShowTable(true);
    //   clearTimeout(tableTimer.current);
    // }, 1000);
  };

  // 取得合併子單號長度
  const getSubMergeTransId = (id) => {
    const mergedIds = id
      .trim()
      .split(',')
      .map((item) => item.substring(0, 10))
      .toString()
      .replaceAll(',', '');
    return mergedIds.length;
  };

  const handleTransIdChange = (value, fromSubTransId = false) => {
    resetTransInfo();
    if (transIdErr) {
      setTransIdErr(false);
    }
    setMeasureStyle(0);
    setTransId(value);
    realTimeTransId.current = value;
    if (value.length === 10 && !regex.SINTERING_TRANS_ID.test(value)) {
      setTransIdErr(true);
      return;
    }
    if ((fromSubTransId || value.length === 10) && finalTransId.current === '') {
      handleTransBlur({
        pass: true,
        callByMeasureStyleChange: false,
        type: 'blur',
      });
    }
    isMultipleTransId.current = false;
    // 判斷merge單選 輸入格式對不對
    const isMerge = realTimeTransId.current.includes(',') && !realTimeTransId.current.includes('-');
    const isSubMerge =
      realTimeTransId.current.includes(',') && realTimeTransId.current.includes('-');

    // 合併單號
    if (isMerge) {
      if (
        realTimeTransId.current.trim().replaceAll(',', '').length % 10 === 0 &&
        realTimeTransId.current.substring(realTimeTransId.current.length - 1) !== ','
      ) {
        handleTransBlur({
          pass: true,
          callByMeasureStyleChange: false,
          type: 'blur',
          isMultiple: true,
        });
        isMultipleTransId.current = true;
      }
      return;
    }

    // 合併子單號
    if (isSubMerge) {
      if (
        getSubMergeTransId(realTimeTransId.current) % 10 === 0 &&
        realTimeTransId.current.substring(realTimeTransId.current.length - 1) !== ','
      ) {
        handleTransBlur({
          pass: true,
          callByMeasureStyleChange: false,
          type: 'blur',
          isMultiple: true,
        });
        isMultipleTransId.current = true;
      }
      return;
    }
  };

  const handleTransInfoChange = (e) => {
    resetTransInfoErr();
    setTransInfo((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    if (e.target.name === 'elecStoveNo') {
      elecStoveNumber.current = e.target.value;
    }
  };

  const handleMeasureStyleChange = (e) => {
    setMeasureStyle(e.target.value);
    currentMeasureStyle.current = e.target.value;
  };

  const handleSubSpecChange = (specRecipe) => {
    // Only for measureStyle DB
    if (showTable && currentSubSpec.current !== '' && currentSubSpec.current !== lastSubSpec) {
      dialogDispatch({
        type: dialogActions.OPEN,
        config: {
          title: '檢測資料尚未儲存',
          message:
            '目前的檢測資料尚未儲存，點擊確認將會放棄此次編輯！若您要保存檢測資料，請先關閉要保存檢測資料，請先關閉此對話框，並點選下方【送出】按鈕儲存！',
          handleConfirm: () => {
            // eslint-disable-next-line no-use-before-define
            currentSubSpec.current = specRecipe;
          },
        },
      });
      return;
    }
    setLastSubSpec(specRecipe);
    currentSubSpec.current = specRecipe;
  };

  const handleResultNoteChange = (e) => {
    setResultNote(e.target.value);
  };

  const openWarningSnackBar = (msg) => {
    setWarningMsg(msg);
    window.scrollTo({
      top: 300,
      behavior: 'smooth',
    });
    clearTimeout(warningTimer.current);
    warningTimer.current = setTimeout(() => {
      setWarningMsg('');
      clearTimeout(warningTimer.current);
    }, 6000);
  };

  const openSuccessSnackBar = (msg) => {
    setSuccessMsg(msg);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    clearTimeout(successTimer.current);
    successTimer.current = setTimeout(() => {
      setSuccessMsg('');
      clearTimeout(successTimer.current);
    }, 3000);
  };

  const setSpecData = (specConfigList) => {
    const sample = sampleQty.current;
    const specItemsFilter = specConfigList.filter(
      (spec) => spec.styleId === currentMeasureStyle.current
    );
    setRenderRow(
      Array.from({ length: sample }, (v, i) => ({
        rowId: i,
        specItems: specItemsFilter.map((spec) => ({
          specId: spec.specId,
          specItem: spec.specItem,
          specRecipe: spec.specRecipe,
          value: '',
        })),
        defectType: [...transDefectTypes.current],
      }))
    );
  };

  const getSpecDetail = async (props) => {
    const { sinterCheckArr, specConfigList } = props;
    let { callBySubSpecChange, type } = props;
    callBySubSpecChange = callBySubSpecChange || false;
    type = type || 'click';

    const subTransId = sinterCheckArr.find((item) => item.transId === realTimeTransId.current);
    currentSubTransId.current = subTransId;
    const cancelToken = newCancelToken();
    if (type === 'blur' || type === undefined) {
      if (currentIsRStick.current === 0) {
        currentMeasureStyle.current = measureStyleType.Z;
        lastMeasureStyle.current = measureStyleType.Z;
      }
      if (currentIsRStick.current === 1) {
        lastMeasureStyle.current = measureStyleType.N;
        currentMeasureStyle.current = measureStyleType.N;
      }
    }
    const data = {
      styleId: currentMeasureStyle.current,
      sizeType: 0,
    };
    if (!subTransId) {
      setIsLoading(false);
      dialogDispatch({
        type: dialogActions.OPEN,
        config: {
          title: '無法取得檢測資料',
          message: '目前無法取得檢測資料，請稍後再試，或請通知網管人員！',
          handleConfirm: () => resetAllField(),
        },
      });
      return;
    }
    if (subTransId.mergedCheckIds && realTimeTransId.current.includes(',')) {
      data.mergedCheckIds = subTransId.mergedCheckIds;
    } else {
      data.sinterCheckId = subTransId.sinterCheckId;
    }
    await getSinterCheck({
      data,
      cancelToken,
      onSuccess: (result) => {
        const { sinterCheck, sinterRow } = result;
        const { isPassElec, isManualPassElec, elecComment, elSizeMergeNo, elecUser } = sinterCheck;
        setEnableDelete(!!elecUser);
        const dataSpecConfig = sinterRow[0].checkDetailList;
        measureConfig.current = dataSpecConfig[0]?.measureConfig;
        dataSpecConfig.forEach((spec) => {
          if (ampSpec.current.includes(spec.measureRecipe)) return;
          ampSpec.current.push(spec.measureRecipe);
        });

        const currentSpecConfigList = specConfigList.filter(
          (spec) => spec.styleId === currentMeasureStyle.current
        );
        if (currentMeasureStyle.current === measureStyleType.DB) {
          let subSpec;
          if (sinterRow[0].checkDetailList.length === 0) {
            // 預設Amp（尚未輸入資料時）
            subSpec = currentSpecConfigList.find((item) => item.isEnabled).specRecipe;
          } else {
            // 預設Amp（已輸入資料時）
            subSpec = sinterRow[0].checkDetailList[0].measureRecipe;
          }
          currentSubSpec.current = subSpec;
        }
        const { modifiedCurrentSpecConfig, currentDiff, dataDiff } = checkSpecConfigDiff(
          currentSpecConfigList && currentSpecConfigList,
          dataSpecConfig
        );
        setTransInfo((prev) => ({
          ...prev,
          sinterCheckId: subTransId.sinterCheckId,
          mergedCheckIds: subTransId.mergedCheckIds,
          rowMapperId: sinterRow[0].rowMapperId,
          elSizeMergeNo,
        }));
        setSinterManualResult(
          typeof isManualPassElec !== 'undefined' ? !!isManualPassElec : !!isPassElec || null
        );
        setOriginalSinterManualResult(
          typeof isManualPassElec !== 'undefined' ? !!isManualPassElec : null
        );
        lastTransId.current = realTimeTransId.current;
        setResultNote(elecComment);
        formResult.current = !!isPassElec;
        if (sinterRow.length <= 1) {
          const enabledSpecConfig = specConfigList.filter((spec) => spec.isEnabled);
          setSpecConfig(enabledSpecConfig);
          setSpecData(enabledSpecConfig);
        } else {
          setSpecConfig(modifiedCurrentSpecConfig);
          setRenderRow(
            sinterRow.map((row, idx) => {
              const specItems = row.checkDetailList.map((col) => {
                const targetSpec = modifiedCurrentSpecConfig.find(
                  (spec) => spec.specId === col.measureId.toString()
                );
                // 只有data有的部分，要標示為已刪除
                const targetItem = dataDiff.find(
                  (item) => item.specId === col.measureId.toString()
                );
                return {
                  specId: col.measureId.toString(),
                  specItem: targetSpec ? targetSpec.specItem : col.measureId,
                  value: col.detailValue,
                  detailId: col.sinterDetailId,
                  sinterId: row.sinterRowId,
                  specRecipe: col.measureRecipe,
                  colStatus: targetItem
                    ? specConfigItemStatus.REMOVED
                    : specConfigItemStatus.CURRENT,
                };
              });
              setDiffNLMeasure(dataDiff);
              currentDiff.forEach((item) =>
                specItems.push({
                  specId: item.specId,
                  specItem: item.specItem,
                  value: '',
                  detailId: 0,
                  sinterId: 0,
                  specRecipe: item.specRecipe,
                  colStatus: specConfigItemStatus.ADDED,
                })
              );
              const sortedSpecItems = specItems.sort(
                (a, b) => b.colStatus - a.colStatus || a.specId - b.specId
              );
              const rowDetail = {
                rowId: idx,
                sinterRowId: row.sinterRowId,
                sinterCheckId: row.sinterCheckId,
                specItems: sortedSpecItems,
              };
              return rowDetail;
            })
          );
        }
        handleShowTable(type);
      },
      onError: (_result, _rtCode, noPrivilegeMsg) => {
        dialogDispatch({
          type: dialogActions.OPEN,
          config: {
            title: '無法取得檢測資料',
            message: noPrivilegeMsg || '目前無法取得檢測資料，請稍後再試，或請通知網管人員！',
            singleBtn: true,
          },
        });
      },
      onSettled: () => {
        setIsLoading(false);
      },
    });
  };

  const validationMultipleTransIds = () =>
    realTimeTransId.current
      .split(',')
      .filter((x) => x)
      .every((id) => regex.SINTERING_TRANS_ID.test(id) || regex.SINTERING_SUBTRANS_ID.test(id));

  const validationTransId = (props) => {
    let { pass, callBySubSpecChange, isMultiple } = props;
    pass = pass || false;
    callBySubSpecChange = callBySubSpecChange || false;
    isMultiple = isMultiple || false;

    if (!pass && !callBySubSpecChange && realTimeTransId.current === currentTransId.current) {
      return false;
    }
    if (realTimeTransId.current.length === 0) {
      return false;
    }
    if (
      !isMultiple &&
      !regex.SINTERING_TRANS_ID.test(realTimeTransId.current) &&
      !regex.SINTERING_SUBTRANS_ID.test(realTimeTransId.current)
    ) {
      setTransIdErr(true);
      return false;
    }
    if (isMultiple && !validationMultipleTransIds()) {
      setTransIdErr(true);
      return false;
    }
    if (!pass && showTable && showUnfinishAlert) {
      dialogDispatch({
        type: dialogActions.OPEN,
        config: {
          title: '檢測資料尚未儲存',
          message:
            '目前的檢測資料尚未儲存，點擊確認將會放棄此次編輯！若您要保存檢測資料，請先關閉要保存檢測資料，請先關閉此對話框，並點選下方【送出】按鈕儲存！',
          handleConfirm: () => {
            setShowTable(false);
            // 進行下一次request前先將currentMeasureStyle跟measureStyle設為預設值 -> 電性檢測時預設為N
            currentMeasureStyle.current = measureStyleType.N;
            setMeasureStyle(measureStyleType.N);
            // eslint-disable-next-line no-use-before-define
            handleTransBlur({ pass: true });
          },
        },
      });
      return false;
    }
    return true;
  };

  const isNotRepeatTransId = (transIds) => {
    const isRepeat = transIds
      .split(',')
      .filter((element, index, arr) => arr.indexOf(element) === index);
    return isRepeat;
  };

  const handleShowDetailContainer = () => {
    setShowPaper(true);
  };

  const handleTransBlur = async (props) => {
    let { pass, callByMeasureStyleChange, isMultiple } = props;
    const { type } = props;
    pass = pass || false;
    callByMeasureStyleChange = callByMeasureStyleChange || false;
    isMultiple = isMultiple || false;

    if (
      !validationTransId({
        pass,
        callBySubSpecChange: callByMeasureStyleChange,
        isMultiple: isMultiple || isMultipleTransId.current,
      })
    )
      return;
    if (type === 'blur') setMeasureStyle(0);
    setResultNote('');
    currentTransId.current = realTimeTransId.current;
    lastMeasureStyle.current = currentMeasureStyle.current;
    const currentStyleId =
      callByMeasureStyleChange || pass
        ? currentMeasureStyle.current !== 0
          ? currentMeasureStyle.current
          : styleId.current
        : measureStyleType.N;
    setShowTable(false);
    setIsLoading(true);
    const cancelToken = newCancelToken();
    await getSinterBase({
      data: {
        transId: realTimeTransId.current,
        styleId: type === 'blur' ? -1 : currentStyleId,
        sizeType: 3,
      },
      cancelToken,
      onSuccess: (result) => {
        const { check, machine, transfer, measure, detect, isLMeasure, sampleCount } = result;
        const {
          customerAlias,
          prodName,
          machineName,
          isRStick,
          transQuantity,
          elecStoveNo,
          materialName,
        } = transfer[0];
        isMultipleTransQty.current = 0;
        finalTransId.current = '';

        sampleQty.current = sampleCount;

        if (!elecStoveNo) {
          dialogDispatch({
            type: dialogActions.OPEN,
            config: {
              title: '燒結移轉單尚未送出',
              message: '此移轉單尚未完成燒結，不得輸入燒結尺寸/電性！',
              singleBtn: true,
            },
          });
          return;
        }

        if (transfer.length > 1) {
          // 若輸入框最後的值不是「,」就讓輸入框自動呈現合併單號
          if (
            realTimeTransId.current.trim().substring(realTimeTransId.current.length - 1) !== ','
          ) {
            const value = transfer.map((item) => item.transId).toString();
            realTimeTransId.current = value;
            // finalTransId.current = value; // 這裡不能設值，否則會導致handleTransBlur的validationTransId判斷失效
            setTransId(realTimeTransId.current);
          }
          isMultipleTransQty.current = transfer
            .map((item) => item.transQuantity)
            .reduce((a, b) => a + b);
        }

        if (!transQuantity) {
          dialogDispatch({
            type: dialogActions.OPEN,
            config: {
              title: '未完成壓型',
              message: '此移轉單未完成壓型移轉單更新，無法做燒結尺寸檢測！',
              singleBtn: true,
            },
          });
          return;
        }
        if (!measure || measure.length === 0) {
          dialogDispatch({
            type: dialogActions.OPEN,
            config: {
              title: '未設定量測項目',
              message: '此料號尚未設定相關的量測項目，請聯絡網管人員先建立相關的量測項目！',
              singleBtn: true,
            },
          });
          return;
        }

        currentIsRStick.current = isRStick;
        // 清空上一次送出的 NL 量測規格
        setDiffNLMeasure([]);
        ampSpec.current = [];

        // eslint-disable-next-line no-unused-expressions
        measure.filter((style) => style.styleName !== '線圈設定').length === 1
          ? setOneColumn(true)
          : setOneColumn(false);
        setTransInfo((prev) => ({
          ...prev,
          transId: realTimeTransId.current,
          isRStick,
          customer: customerAlias,
          elName: `${prodName}(${materialName})`,
          elecStoveNo: elecStoveNo || elecStoveNumber.current,
          transQty:
            isMultiple || isMultipleTransId.current
              ? transfer.map((item) => item.transQuantity).reduce((a, b) => a + b)
              : transQuantity || '-',
          position: prev.position === '0' ? positionType.FRONT : prev.position,
          layer: prev.layer === '0' ? 1 : prev.layer,
          machineName: machineName || '0',
          isLMeasure,
        }));
        if (detect && detect.length > 0) {
          // eslint-disable-next-line no-shadow
          transDefectTypes.current = detect.map((type) => ({
            name: type.detectId.toString(),
            label: type.detectName,
            checked: false,
          }));
        }
        setSubTransIds(
          check
            .filter((item) => item.transId !== '')
            .map((item) => ({
              transId: item.transId,
              sinteringId: item.sinterCheckId,
              mergedIds: item.mergedCheckIds,
            }))
        );
        if (machine && machine.length > 0) {
          setElecStoveSelection(
            machine.map((item) => ({
              name: item.machineName,
              value: item.machineId,
            }))
          );
        }
        // 取出「線圈、星號」且是 isEnabled 的資料
        currentMeasureConfig.current = measure
          .filter(
            (spec) =>
              (spec.styleId === measureStyleType.COIL || spec.styleId === measureStyleType.STAR) &&
              spec.isEnabled
          )
          .map((spec) => ({
            measureId: spec.measureId,
            styleId: spec.styleId,
          }));
        const specConfigList = measure.map((spec) => ({
          specId: spec.measureId.toString(),
          specItem: spec.measureItem.trim(),
          specTarget: spec.measureTarget.trim() || '',
          specUpper: spec.measureUpperSpec.trim() || '',
          specLower: spec.measureLowerSpec.trim() || '',
          specBias: spec.measureDeviation.trim(),
          limitUpper: spec.measureUpperLimit.trim() || '',
          limitLower: spec.measureLowerLimit.trim() || '',
          specRecipe: spec.measureRecipe.trim() || '',
          styleId: spec.styleId,
          styleName: spec.styleName.trim(),
          isEnabled: !!spec.isEnabled,
          measureConfig: spec.measureConfig || currentMeasureConfig.current,
          isActive: true,
        }));
        setCurrentSpec(specConfigList);
        inspectionCheck.current = check;
        inspectionSpecConfig.current = specConfigList;
        handleShowDetailContainer();
        // 量測型態的【查詢】按鈕點擊後才呼叫getSpecDetail
        if (callByMeasureStyleChange) {
          getSpecDetail({
            sinterCheckArr: inspectionCheck.current,
            specConfigList,
            callBySubSpecChange: callByMeasureStyleChange,
            type,
          });
        } else {
          setIsLoading(false);
        }
      },
      onError: (result, rtCode, noPrivilegeMsg) => {
        setIsLoading(false);
        if (isMultiple) {
          const lastTransIds = realTimeTransId.current.split(',');
          lastTransIds.pop();
          dialogDispatch({
            type: dialogActions.OPEN,
            config: {
              title: '無法取得移轉單資料',
              message: result,
              singleBtn: true,
              handleConfirm: () =>
                rtCode === 'C01'
                  ? setTransId(isNotRepeatTransId(realTimeTransId.current).toString())
                  : setTransId(lastTransIds.toString()),
            },
          });
          return;
        }
        dialogDispatch({
          type: dialogActions.OPEN,
          config: {
            title: rtCode === 'C01' ? '壓型移轉單尚未送出' : '無法取得移轉單資料',
            message:
              rtCode === 'C01'
                ? result
                : '目前無法取得該移轉單號之資料，請稍後再試，或請通知網管人員！',
            singleBtn: true,
          },
        });
      },
    });
  };

  const validationSubSpec = () => {
    if (!showTable) return true;
    if (currentMeasureStyle === 0) {
      return false;
    }
    if (currentMeasureStyle.current === lastMeasureStyle.current && !isMultipleTransId.current) {
      return false;
    }
    return true;
  };

  const handleFetchDifferentMeasureStyle = () => {
    if (!validationSubSpec()) return;
    setShowTable(false);
    handleTransBlur({
      pass: true,
      callByMeasureStyleChange: true,
    });
  };

  const handleDBMeasureStyleFormSubmit = (rowData) =>
    // 1. rowData帶的是目前要儲存的是currentSubSpec的那個Amp分頁的資料 -> specItems中只有specRecipe === currentSubSpec的column
    // 2. renderRow是完整的row資料 -> specItems中有所有的column
    // 3. map renderRow, 檢查每一row內的specItems的每個spec, 若specRecipe === currentSubSpec, 將該spec的資料替換成rowData中的資料, 若不是currentSubSpec的話, 則保留原本renderRow中的資料
    renderRow.map((row) => ({
      ...rowData.find((item) => item.rowId === row.rowId),
      specItems: row.specItems.map((spec) => {
        if (
          spec.specRecipe === currentSubSpec.current &&
          spec.colStatus !== specConfigItemStatus.REMOVED
        ) {
          const targetRow = rowData.find((item) => item.rowId === row.rowId);
          const targetSpec = targetRow.specItems.find((item) => item.specId === spec.specId);
          return targetSpec;
        }
        return spec;
      }),
    }));

  const handleManualResultDifferFromSystemResult = (rowData) => {
    setTimeout(() => {
      dialogDispatch({
        type: dialogActions.OPEN,
        config: {
          title: '您是否確定要送出？',
          message: `人工判定結果為【${sinterManualResult ? '通過' : '不通過'}】，系統判定結果為【${
            outSpecCount.current > 0 ? '不通過' : '通過'
          }】，兩者判定結果不同！若確認結果無誤，按下確認後，資料將寫入資料庫`,
          handleConfirm: () => handleSaveForm(rowData, true),
          handleCancel: () => setIsSubmitting(false),
        },
      });
    }, 100);
  };

  const handleSaveForm = async (rowData, resultDifferenceConfirmed = false) => {
    if (
      !resultDifferenceConfirmed &&
      ((outSpecCount.current > 0 && sinterManualResult) ||
        (outSpecCount.current === 0 && !sinterManualResult))
    ) {
      handleManualResultDifferFromSystemResult(rowData);
      return;
    }
    infoDialogDispatch({
      type: dialogActions.OPEN,
      config: {
        title: '資料儲存中',
        message: '資料儲存中，請稍候...',
        noBtn: true,
        disableBackdropClick: true,
      },
    });
    let requestRowData = rowData;
    if (measureStyle === measureStyleType.DB) {
      requestRowData = handleDBMeasureStyleFormSubmit(rowData);
    }
    const { mergedCheckIds, sinterCheckId, elecStoveNo, transQty, machineName, elSizeMergeNo } =
      transInfo;

    // 判斷送出時transId最後一個字是否為「,」，若是的話需把「,」拿掉再送出
    realTimeTransId.current =
      realTimeTransId.current.substring(realTimeTransId.current.length - 1) !== ','
        ? realTimeTransId.current
        : realTimeTransId.current.substring(0, realTimeTransId.current.length - 1);
    setTransId(realTimeTransId.current);

    const sinterCheck = {
      mergedCheckIds,
      sinterCheckId,
      transId: realTimeTransId.current,
      elecStoveNo,
      machineName,
      elSizeMergeNo,
      isManualPassElec: sinterManualResult ? 1 : 0,
    };
    // 多個移轉單單號
    if (mergedCheckIds) {
      sinterCheck.mergeQuantity = transQty === '-' ? 0 : transQty;
    }
    // 單個移轉單單號
    if (sinterCheckId) {
      sinterCheck.transQuantity = transQty === '-' ? 0 : transQty;
    }
    // sinterCheck.isPassElec = formResult.current ? 1 : 0;
    sinterCheck.isPassElec = requestRowData.some((item) => item.isOutSpec) ? 0 : 1; // TODO: 20250304 Shane - 嘗試修復有時候N量測值量測內容無NG，但isPassElec卻為0的問題
    sinterCheck.elecComment = resultNote;
    const currentStyleId = lastMeasureStyle.current;
    const data = {
      sinterCheck,
      sinterRow: requestRowData.map((row) => {
        const rowDetail = {
          rowMapperId: transInfo.rowMapperId,
          sinterCheckId,
          sizeType,
          styleId: currentStyleId,
          sinterRowId: row.sinterRowId || 0,
          checkDetailList: row.specItems
            .filter(
              (item) =>
                !(
                  item.colStatus === specConfigItemStatus.REMOVED &&
                  item.specRecipe === currentSubSpec.current
                )
            )
            .map((spec) => ({
              sinterDetailId: spec.detailId || 0,
              sinterRowId: row.sinterRowId || 0,
              measureId: spec.specId,
              detailValue: spec.value,
              measureConfig: currentMeasureConfig.current,
            })),
        };
        if (!row.isEmpty) {
          // 判斷每一row有沒有超過限制範圍
          rowDetail.isPass = row.isOutSpec ? 0 : 1;
        } else {
          rowDetail.isPass = -1;
        }
        return rowDetail;
      }),
    };
    const cancelToken = newCancelToken();
    await sinterCheckSetting({
      data,
      cancelToken,
      onSuccess: () => {
        setShowTable(false);
        infoDialogDispatch({
          type: dialogActions.CLOSE,
        });
        openSuccessSnackBar(`移轉單號 ${transId} 的燒結檢測儲存成功！`);
      },
      onError: (result, _rtCode, noPrivilegeMsg) => {
        setShowUnfinishAlert(false);
        infoDialogDispatch({
          type: dialogActions.CLOSE,
        });
        dialogDispatch({
          type: dialogActions.OPEN,
          config: {
            title: '無法儲存檢測資料',
            message:
              result ||
              noPrivilegeMsg ||
              '目前暫時無法儲存檢測資料，請稍後再試，或請通知網管人員！',
            singleBtn: true,
          },
        });
      },
      onSettled: () => {
        setIsSubmitting(false);
      },
    });
  };

  const validationRowData = (rowData) => {
    const inValidRowIndex = [];
    const hasInvalidRow = rowData.map((row, idx) => {
      const { isInvalid, isEmpty } = row;
      if ((!isInvalid && !isEmpty) || (isInvalid && isEmpty)) {
        // 所有欄位都有填跟所有欄位都不填都算valid
        return true;
      }
      inValidRowIndex.push(idx + 1);
      setRenderRow((prev) =>
        prev.map((item) => {
          if (item.rowId === row.rowId) {
            const rowDetail = {
              ...item,
              specItems: [...row.specItems],
              isInvalid: true,
            };
            return rowDetail;
          }
          return item;
        })
      );
      return false;
    });
    if (inValidRowIndex.length > 0) {
      let msg = '';
      if (inValidRowIndex.length < 10) {
        msg = `請注意！！第 ${inValidRowIndex.join(
          ', '
        )} 筆量測資料沒有輸入完全，量測結果不得送出！！`;
      } else {
        msg = `請注意！！共有 ${inValidRowIndex.length} 筆量測資料沒有輸入完全，量測結果不得送出！！`;
      }
      openWarningSnackBar(msg);
    }
    return hasInvalidRow.every((x) => x);
  };

  const handleEmptyRow = (emptyRowIdx, rowData) => {
    const ngNum = outSpecCount.current;

    if (emptyRowIdx.length === 0) return;
    if (emptyRowIdx.includes(1)) {
      openWarningSnackBar('請從第一筆資料開始填寫！');
      return;
    }
    const sampleCount = sampleQty.current;
    dialogDispatch({
      type: dialogActions.OPEN,
      config: {
        title: '您是否確定要送出？',
        message: `總共量測 ${sampleCount} 筆， ${ngNum} 筆NG，第 ${emptyRowIdx.join(
          ', '
        )} 筆資料為空，按下確認後，資料將寫入資料庫`,
        handleConfirm: () => handleSaveForm(rowData),
      },
    });
  };

  const validationEmptyRow = (rowData, validRowData) => {
    const emptyRowIndex = [];
    const hasEmptyRow = rowData.map((row, idx) => {
      const { isInvalid, isEmpty, isOutSpec } = row;
      if (isOutSpec) {
        outSpecCount.current += 1;
      }
      if (!isInvalid && !isEmpty) {
        return true;
      }
      emptyRowIndex.push(idx + 1);
      setRenderRow((prev) =>
        prev.map((item) => {
          if (item.rowId === row.rowId) {
            const rowDetail = {
              ...item,
              specItems: [...row.specItems],
              isEmpty: true,
            };
            return rowDetail;
          }
          return item;
        })
      );
      return false;
    });
    handleEmptyRow(emptyRowIndex, validRowData);
    return hasEmptyRow.every((x) => x);
  };

  const validationOutSpec = (validRowData) => {
    const ngNum = outSpecCount.current;
    if (outSpecCount.current > 0) {
      const sampleCount = sampleQty.current;
      dialogDispatch({
        type: dialogActions.OPEN,
        config: {
          title: '您是否確定要送出？',
          message: `總共量測 ${sampleCount} 筆， ${ngNum} 筆NG，按下確認後，資料將寫入資料庫`,
          handleConfirm: () => handleSaveForm(validRowData),
        },
      });
      return false;
    }
    return true;
  };

  const handleFormSubmit = () => {
    setIsSubmitting(true);
    resetTransInfoErr();
    if (!validationTransInfo()) {
      setIsSubmitting(false);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      return;
    }
    // Gather all data from every row
    const allRowsData = renderRow.map((item) => item.gatherData(true, specConfig));
    outSpecCount.current = 0;
    formResult.current = !allRowsData.some((row) => row.isOutSpec);
    if (!validationRowData(allRowsData)) {
      setIsSubmitting(false);
      return;
    }
    const validAllRowsData = renderRow.map((item) => item.gatherData(false, specConfig)); // 儲存時僅儲存colStatus
    if (
      !validationEmptyRow(allRowsData, validAllRowsData) ||
      !validationOutSpec(validAllRowsData)
    ) {
      setIsSubmitting(false);
      return;
    }
    handleSaveForm(validAllRowsData);
  };

  const handleFocusChange = (e) => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      e.preventDefault();
      const nextTabIndex = e.target.tabIndex + 1;
      const nextEl = document.querySelectorAll(`[tabindex="${nextTabIndex}"]`)[1];
      if (!nextEl) return;
      nextEl.focus();
    }
  };
  const handleDelete = async () => {
    setDisabledDeleteBtn(true);
    setIsLoading(true);
    infoDialogDispatch({
      type: dialogActions.OPEN,
      config: {
        title: '資料刪除中',
        message: '資料刪除中，請稍候...',
        noBtn: true,
        disableBackdropClick: true,
      },
    });
    const cancelToken = newCancelToken();
    const data = {
      transId: realTimeTransId.current,
      rowMapperId: transInfo.rowMapperId,
      sinterCheckId: transInfo.sinterCheckId,
      sizeType: 3,
      styleId: currentMeasureStyle.current,
    };
    await deleteTransferQcData({
      data,
      cancelToken,
      onSuccess: () => {
        dialogDispatch({
          type: dialogActions.OPEN,
          config: {
            title: '刪除成功',
            message: `已刪除${realTimeTransId.current}的資料！`,
            singleBtn: true,
            handleConfirm: resetAllField,
          },
        });
      },
      onError: (result, rtCode, noPrivilegeMsg) => {
        dialogDispatch({
          type: dialogActions.OPEN,
          config: {
            title: '無法刪除',
            message:
              rtCode === 'C01'
                ? result
                : noPrivilegeMsg ||
                  `目前暫時無法刪除${realTimeTransId.current}的資料請稍後再試，或請通知網管人員！`,
            singleBtn: true,
          },
        });
      },
      onSettled: () => {
        setDisabledDeleteBtn(false);
        setIsLoading(false);
        infoDialogDispatch({
          type: dialogActions.CLOSE,
        });
      },
    });
  };

  const handleShowConfirmDelete = () => {
    dialogDispatch({
      type: dialogActions.OPEN,
      config: {
        title: `確認刪除？`,
        message: `刪除之後無法復原，確認刪除${realTimeTransId.current}的此筆資料嗎？`,
        singleBtn: false,
        handleConfirm: handleDelete,
      },
    });
  };

  // 監聽是否為合併檢測單
  useEffect(() => {
    if (
      transId.includes(',') &&
      (realTimeTransId.current.trim().replaceAll(',', '').length % 10 === 0 ||
        getSubMergeTransId(realTimeTransId.current) % 10 === 0)
    ) {
      isMultipleTransId.current = true;
    }
    if (!transId.includes(',')) {
      isMultipleTransId.current = false;
    }
    if (finalTransId.current !== transId) {
      setShowTable(false);
    }

    if (transId.length === 0) {
      // 清空數量的數字
      isMultipleTransQty.current = 0;
      finalTransId.current = '';
      // 清空子單號
      setSubTransIds([]);
    }
  }, [transId]);

  useEffect(() => {
    if (showTable && tableEl.current) {
      tableEl.current.addEventListener('keydown', handleFocusChange);
    }

    return () => {
      if (!tableEl.current) return;
      tableEl.current.removeEventListener('keydown', handleFocusChange);
    };
  }, [showTable]);

  useEffect(() => {
    if (transInfo.isRStick === 0) {
      setMeasureStyle(measureStyleType.Z);
      currentMeasureStyle.current = measureStyleType.Z;
      lastMeasureStyle.current = measureStyleType.Z;
      return;
    }
    setMeasureStyle(measureStyleType.N);
    lastMeasureStyle.current = measureStyleType.N;
    currentMeasureStyle.current = measureStyleType.N;
  }, [transInfo.isRStick, transId]);

  useEffect(() => {
    resetAllField();
  }, []);

  useEffect(
    () => () => {
      clearTimeout(tableTimer.current);
      clearTimeout(warningTimer.current);
      clearTimeout(successTimer.current);
    },
    []
  );

  return (
    <div className={commonClasses.main}>
      <PageTitle title="燒結電性檢測" />
      <TransInfo
        transId={transId}
        transIdErr={transIdErr}
        subTransIds={subTransIds}
        elecStoveSelection={elecStoveSelection}
        multipleTransQty={isMultipleTransQty.current}
        transInfo={transInfo}
        transInfoErr={transInfoErr}
        // 20250122 Shane - 若是R棒，有多種量測型態，在選擇量測型態後，點擊查詢才取得資料並顯示；若是非R棒，僅有一種量測型態，則在點擊確認後直接取得資料並顯示
        handleFetch={
          transInfo.isRStick ? handleShowDetailContainer : handleFetchDifferentMeasureStyle
        }
        isLoading={isLoading}
        // handleFetch={handleFetchDifferentMeasureStyle}
        handleTransIdChange={handleTransIdChange}
        handleTransInfoChange={handleTransInfoChange}
        path={sinteringSizePath.ELECTRICAL}
        resetTransInfo={resetTransInfoField}
        setResetTransInfo={setResetTransInfoField}
        transIdErrMsg={transIdErrMsg}
        setShowTable={setShowTable}
      />
      <Snackbar
        msg={successMsg}
        open={successMsg.length > 0}
        type="success"
        className={commonClasses.success_snackbar}
      />
      <Snackbar
        msg={warningMsg}
        open={warningMsg.length > 0}
        type="error"
        className={commonClasses.error_snackbar}
      />
      <QCSinteringElectrical
        isRStick={transInfo.isRStick}
        measureStyle={measureStyle}
        lastMeasureStyle={lastMeasureStyle.current}
        handleMeasureStyleChange={handleMeasureStyleChange}
        handleFetchDifferentMeasureStyle={handleFetchDifferentMeasureStyle}
        showTable={showTable}
        showPaper={showPaper}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
        currentSubSpec={currentSubSpec.current}
        currentSpec={currentSpec}
        measureConfig={measureConfig.current}
        diffNLMeasure={diffNLMeasure}
        ampSpecConfig={ampSpec.current}
        specConfig={specConfig}
        setSpecConfig={setSpecConfig}
        renderRow={renderRow}
        setRenderRow={setRenderRow}
        handleSubSpecChange={handleSubSpecChange}
        resultNote={resultNote}
        handleResultNoteChange={handleResultNoteChange}
        handleFormSubmit={handleFormSubmit}
        isLMeasure={transInfo.isLMeasure}
        currentMeasureStyle={currentMeasureStyle.current}
        oneColumn={oneColumn}
        rowLength={sampleQty.current}
        handleDelete={handleShowConfirmDelete}
        disabled={disabledDeleteBtn}
        enableDelete={enableDelete}
        sinterManualResult={sinterManualResult}
        setSinterManualResult={setSinterManualResult}
        originalSinterManualResult={originalSinterManualResult}
      />
    </div>
  );
};

export default QCSinteringElectricalPage;
